import config from 'config'

export const getImageURL = (image, width, height) => {
  const nextSizeW = width * (window.devicePixelRatio > 1 ? 2 : 1)
  const nextSizeH = (height || width) * (window.devicePixelRatio > 1 ? 2 : 1)
  return image && `${config.resizerURL}image/crop/${nextSizeW}x${nextSizeH}/${image.replace(/^https?:\/\//i, '')}`
}
